import { Component, OnInit, Inject, ElementRef, HostListener, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { IAttributes } from 'src/app/models/IAttributes';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { ToastrService } from 'ngx-toastr';
import { formatDate, DatePipe } from '@angular/common';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { AssessmentClinicService } from 'src/app/Services/NewORNote/assessment.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { NgxSpinnerService } from "ngx-spinner";
//import { ConfirmDialogModel, DeleteDocumentDialogComponent } from 'src/app/PatientChart/documents/import-document/delete-document-dialog/delete-document-dialog.component';

export interface DialogData {
  attributelist: IAttributes[];
  type: string;
}

@Component({
  selector: 'app-addto-combo-box',
  templateUrl: './addto-combo-box.component.html',
  styleUrls: ['./addto-combo-box.component.css']
})
export class AddtoComboBoxComponent implements OnInit {

  AddToDropDownForm: FormGroup;
  dataSource: IAttributes[] = [];
  lstdata: IAttributes[] = [];
  listName: string = "";
  dropdowntype: string = "";
  Isadded: boolean = false;
  message: string;
  ASCTypeObj: IAttributes;
  filteredOptions: Observable<IAttributes[]>;
  SelectedDropDownListId: boolean = false;
  @ViewChild('saveUserId', { static: false }) saveUserId: ElementRef;
  @ViewChild('yourInput', { static: false }) yourInput: ElementRef;
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddtoComboBoxComponent>, private sharedService: SharedService,
    private dateservice: SchedularServiceService, private assessmentClinicService: AssessmentClinicService, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public dialog: MatDialog, private spinner: NgxSpinnerService) { }

  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (event.target.id == "locationsfocus" || event.currentTarget.activeElement.parentElement.id == "userselectLoc") {
      this.SelectedDropDownListId = true
    }
    else {
      event.stopPropagation();
      this.SelectedDropDownListId = false
      // this.yourInput.nativeElement.focus();
      // this.yourInput.nativeElement.setSelectionRange(2,2);
    }
  }

  ngOnInit() {
    $(document).ready(function () {
      setTimeout(() => {
        document.getElementById('dropvalId').focus();
      }, 200);
      
    });

    this.AddToDropDownForm = this.fb.group({
      attributeType: [''],
      attributeName: [''],
      locations: ['', Validators.required],
      IsLocationCheck: [''],
    });

    // this.dataSource = this.data.attributelist;
    // this.listName = this.data.type;
    // if (this.data.attributelist.length > 0) {
    //   this.listName = this.data[0].attributeType;
    // }

    this.dropdowntype = this.data.type;
    if (this.listName === 'Site') {
      this.listName = 'IV Site';
    }
    this.getLocations();
    this.EnterDefaultDateTime();
    this.getdropdownbytypedata();

    // this.filteredOptions = this.AddToDropDownForm.get('attributeType')!.valueChanges.pipe(
    //   startWith(""),
    //   map(value => this._filter(value))
    // );


  }
  onSelectionChanged(event, type: string) {
    // setTimeout(() => {
    //   if (event !== null && event !== undefined) {
    //     $(event.target).prev().trigger('focus');
    //   }
    // }, 100);

  }
  //   ngAfterViewInit(){
  //     this.yourInput.nativeElement.focus();
  //     this.yourInput.nativeElement.setSelectionRange(2,2);
  // }
  getdropdownbytypedata() {
    this.assessmentClinicService.getMasterDataByAttributeType(this.dropdowntype).subscribe((data1: IAttributes[]) => {
      this.lstdata = data1;
      this.getfilterdata();
    });

  }
  getfilterdata() {
    this.filteredOptions = this.AddToDropDownForm.get('attributeType')!.valueChanges.pipe(
      startWith(""),
      map(value => this._filter(value))
    );
  }
  private _filter(value: string): IAttributes[] {
    const filterValue = value.toLowerCase();
    return this.lstdata.filter(option => option.attributeName.toLowerCase().indexOf(filterValue) === 0);
  }

  onSubmit() {
    this.Isadded = false;
    var obj: IAttributes = {
      attributeDesc: '',
      attributeId: this.lstdata.length.toString(),
      //  attributeName: this.AddToDropDownForm.value.attributeName.replace(/\s/g, ""),
      attributeName: this.AddToDropDownForm.value.attributeName,
      attributeType: 'typeOfComboPassed',
      isActive: true,
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      createdOn: new Date(),
      modifiedBy: '',
      modifiedOn: new Date(),
      dbOperations: '',
      claimCode: '',
      encounterId: '',
      selected: null
    }
    if (this.AddToDropDownForm.value.attributeName != "" && this.AddToDropDownForm.value.attributeName != null && this.AddToDropDownForm.value.attributeName != undefined) {
      //  if (obj.attributeName != '') {
      // var index = this.lstdata.forEach(x => {
      //  if (x.attributeId != 'ROOM') {
      // if (x.attributeName.toString().toLowerCase() == obj.attributeName.toString().toLowerCase()) {
      // this.Isadded = true;
      // }
      // }
      // }
      // )
      var filterdata = this.lstdata.filter(d => d.attributeName.toString().toLowerCase() === this.AddToDropDownForm.value.attributeName.toString().toLowerCase())
      if (filterdata.length > 0) {
        if(this.selectedLocationIds.toString().includes(sessionStorage.getItem("LocationId"))){
          this.message = "Record already exists"
        }else{
          this.SaveAssessmentName(obj.attributeName, this.dropdowntype);
        }
        // if (!this.Isadded) {
        //this.dataSource.push(obj);
        // this.dialogRef.close(obj);
       


      } else {
        //this.dialogRef.afterOpen();
        this.SaveAssessmentName(obj.attributeName, this.dropdowntype);
      }
    }
    // else{
    //   var message="Value already added";
    //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
    //   const dialogRef = this.dialog.open(DeleteDocumentDialogComponent, {
    //     maxWidth: '400px',
    //     data: dialogData
    //   });

    // }

  }


  public locationIds: string = '';
  SaveAssessmentName(ASCName, ASCType) {
    this.ASCTypeObj = new IAttributes();
    this.ASCTypeObj.attributeType = ASCType;
    this.ASCTypeObj.attributeName = ASCName;
    this.ASCTypeObj.attributeDesc = ASCName;
    this.ASCTypeObj.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.ASCTypeObj.isActive = true;
    this.ASCTypeObj.encounterId = sessionStorage.getItem("encounterid");
    this.locationIds = this.selectedLocationIds.toString();
    this.sharedService.saveAddComboBoxDetails(this.ASCTypeObj, this.locationIds).subscribe(
      results => {
        this.result = results;
        this.toastr.success(ASCType + " Name Added Successfully");
        this.AddToDropDownForm.controls['attributeName'].setValue('');
        this.AddToDropDownForm.controls['attributeType'].setValue('');
        this.AddToDropDownForm.controls['locations'].setValue('');
        this.AddToDropDownForm.controls['IsLocationCheck'].setValue('');
        this.message = "";
        this.lstdata = [];
        this.getdropdownbytypedata();
        this.dialogRef.close(true);
      }, (err: any) => console.log(err));
  }
  datetime: string = '';
  EnterDefaultDateTime() {
    var today = new Date();
    this.dateservice.getservercurrentdate().subscribe(async result => {

      await result;
      this.datetime = formatDate(result, 'yyyy-MM-dd hh:mm:ss a', 'en-US');
    }
    );
  }
  result: any;
  deleteItem(AscId: string) {
    const message = "Are you sure to delete Record? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '130px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        this.sharedService.DeleteMasterAssessmentName(AscId, this.datetime).subscribe(
          results => {
            this.result = results;
            this.toastr.success(this.result);
            this.AddToDropDownForm.controls['attributeType'].setValue('');
            this.message = "";
            this.lstdata = [];
            this.getdropdownbytypedata();
            this.dialogRef.close(true);
          });
      }
    });
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  focusOutFunctionLocation(evn) {
    if (evn.keyCode === 9) {
      $('#locationsfocushide').hide()
      // setTimeout(() => {
      //   this.saveUserId.nativeElement.focus();
      // }, 100);

      this.SelectedDropDownListId = false;
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocus") {
      //$('#locationlistoption0').focus();
    }
  }

  //SelectedDropDownListId: boolean = false;
  arryOfselectedLocationsIdsUpdate: string[] = [];
  locationNameUpdate: string;
  locationsList: ILocationDetails[];
  selectedLocationIds: string[] = [];
  LocationSelectionChanged(LocationupdateRef) {
    this.locationsList = LocationupdateRef.selectedOptions.selected.map(item => item.value);
    this.locationNameUpdate = '';
    let selectedLocationsIdsUpdate = [];
    this.selectedLocationIds = [];
    this.arryOfselectedLocationsIdsUpdate = [];
    for (let index = 0; index < this.locationsList.length; index++) {
      this.locationNameUpdate += this.locationsList[index].locationName + ', ';
      selectedLocationsIdsUpdate.push(this.locationsList[index].locationId);
      this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
      this.arryOfselectedLocationsIdsUpdate.push(this.locationsList[index].locationId.toString())
    }

    // if(this.locationsList.length > 0 && this.locationsList != null)
    // this.isdisablebtns = false;
    // else
    // this.isdisablebtns = true;

    this.lstLocations.filter(x => x.selected = false) // default set false
    this.lstLocations.filter(x => selectedLocationsIdsUpdate.includes(x.locationId)).map(y => y.selected = true)

    this.AddToDropDownForm.patchValue({
      locations: this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2)
    })

    this.checkDefaultLocations();

  }
  checkDefaultLocations() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.lstLocations.length) {
        this.AddToDropDownForm.patchValue({
          IsLocationCheck: true
        });
      } else {
        this.AddToDropDownForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.AddToDropDownForm.patchValue({
        IsLocationCheck: false
      });
    }

    // if(selectProvlst.length > 0 || this.locationsList.length > 0)
    // this.isdisablebtns = false;
    // else
    // this.isdisablebtns = true;
  }
  public lstLocations: ILocationDetails[];
  //public locationFilter: any;
  locationID: any;
  getLocationId: any;
  name: any;
  getLocations() {
    if ((sessionStorage.getItem("userId") || sessionStorage.getItem("FacilityId")))
      this.dateservice.getLocations().subscribe(data => {
        this.spinner.hide();
        this.lstLocations = data;
        this.selectedLocationIds = [];
        ;
        this.getLocationId = sessionStorage.getItem("LocationId"); //this.patservice.urlValue;//
        if (this.getLocationId == "0") {
          this.locationID = this.lstLocations[0].locationName.toString();
          // this.isdisablebtns = true
        } else {
          this.locationID = this.lstLocations.filter(x => x.locationId === Number(this.getLocationId))
          this.selectedLocationIds.push(this.locationID[0].locationId);
          //this.isdisablebtns = false;
        }

        this.lstLocations.filter(x => x.selected = false) // default set false
        this.lstLocations.filter(x => x.locationId == this.locationID[0].locationId).map(y => y.selected = true);

        this.AddToDropDownForm.patchValue({
          locations: this.locationID[0].locationName,
        });
      });

  }

  selectedList: ILocationDetails[];
  selected: string = "";
  selectedName: string;
  checkAllLocations(event) {

    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    if (ischk == true) {
      // this.isdisablebtns = false;
      this.selectedList = [];
      this.selectedLocationIds = [];
      this.selected = '';
      this.locationNameUpdate = '';
      this.lstLocations = this.lstLocations.filter(x => x.selected = true)
      this.selectedList = this.lstLocations;

      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = true;
        this.selected += this.selectedList[index].locationId + ',';
        this.selectedLocationIds.push(this.selectedList[index].locationId.toString())

        //this.selectedLocationIds.push(this.selected);
        // this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
        this.locationNameUpdate += this.selectedList[index].locationName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.locationNameUpdate = this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2);
      }
      this.AddToDropDownForm.patchValue({
        locations: this.locationNameUpdate
      });
    } else {
      //this.isdisablebtns = true;
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
      }
      this.selectedLocationIds = [];
      //this.selectedLocationIds.push('0')
      this.selected = '';
      this.selectedName = '';
      this.AddToDropDownForm.patchValue({
        locations: this.selectedName
      });
    }




  }
}
